import './MegaMenu.css';

type SU =  string | undefined;
type HTMLElementPin =  HTMLElement | null;

function megaMenu() {
    const menus = Array.from(document.querySelectorAll('[data-megamenu]'));
    const linkActiveClass = 'megamenu__link--active';
    const previewActiveClass = 'megamenu__preview--active';
    
    menus.forEach(menu => {
        const megaLinks = Array.from(menu.querySelectorAll('[data-megalink]'));
        const megaPreviews = Array.from(menu.querySelectorAll('[data-megapreview]'));
        
        const removeCurrentActive = (arr: Element[], classActive: string) => {
            const resActive = arr.filter(el => el.classList.contains(classActive));
            resActive[0].classList.remove(classActive);
        }

        const handleMouseEvent = (id: SU, eventType: string, linkEl: Element) => {
            const previewEl: HTMLElementPin = document.querySelector(`[data-megapreview='${id}']`);

            if(previewEl) {
                if(eventType === 'mouseover') {
                    removeCurrentActive(megaLinks, linkActiveClass);
                    // Add Active class
                    linkEl.classList.add(linkActiveClass);
                    removeCurrentActive(megaPreviews, previewActiveClass);
                    // Add Active class
                    previewEl.classList.add(previewActiveClass);
                }
            }
        }
    
        const setInitialActive = () => {
            const activeLink = megaLinks.filter(link => link.classList.contains(linkActiveClass));
            const activePreview = megaPreviews.filter(preview => preview.classList.contains(previewActiveClass));

            if(activeLink.length > 0 && activePreview.length > 0) { return }

            if(activeLink.length === 0) {
                megaLinks[0].classList.add(linkActiveClass);
            }

            if(activePreview.length === 0) {
                megaPreviews[0].classList.add(previewActiveClass);
            }
        }
        
        if(megaLinks.length > 0) {
            megaLinks.forEach(megalink => {
                let id: SU;
                if (megalink instanceof HTMLElement) {
                    id = megalink.dataset.megalink;
                }
                megalink.addEventListener('mouseover', () => handleMouseEvent(id, 'mouseover', megalink));
            });
            if(megaLinks.length > 0 && megaPreviews.length > 0) 
                setInitialActive();
        }
    });
}

export default megaMenu;